/**
 * Cookie consent — noodzakelijk / analytisch / marketing.
 * Marketing- en analytische scripts laden pas na toestemming.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'uf_cookie_consent_v2';
  var cfg = window.UF_COOKIE_CONSENT || {};
  var privacyUrl = cfg.privacyUrl || '/pages/privacy-verklaring';

  function readConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return null;
      return {
        necessary: true,
        analytics: !!data.analytics,
        marketing: !!data.marketing,
        ts: data.ts || Date.now()
      };
    } catch (e) {
      return null;
    }
  }

  function writeConsent(choices) {
    var payload = {
      necessary: true,
      analytics: !!choices.analytics,
      marketing: !!choices.marketing,
      ts: Date.now()
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
    return payload;
  }

  function ensureApi(cb) {
    window.Shopify = window.Shopify || {};
    if (window.Shopify.customerPrivacy) return cb();
    if (!window.Shopify.loadFeatures) return cb();
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function () { cb(); }
    );
  }

  function syncShopify(choices, cb) {
    ensureApi(function () {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: !!choices.analytics,
            marketing: !!choices.marketing,
            preferences: true,
            sale_of_data: !!choices.marketing
          },
          cb || function () {}
        );
      } else if (cb) {
        cb();
      }
    });
  }

  function updateGtagConsent(choices) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('consent', 'update', {
      analytics_storage: choices.analytics ? 'granted' : 'denied',
      ad_storage: choices.marketing ? 'granted' : 'denied',
      ad_user_data: choices.marketing ? 'granted' : 'denied',
      ad_personalization: choices.marketing ? 'granted' : 'denied'
    });
  }

  function injectHtmlScripts(html) {
    if (!html) return;
    try {
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      wrap.querySelectorAll('script').forEach(function (oldScript) {
        var script = document.createElement('script');
        Array.prototype.forEach.call(oldScript.attributes, function (attr) {
          script.setAttribute(attr.name, attr.value);
        });
        script.text = oldScript.text || oldScript.textContent || '';
        document.head.appendChild(script);
      });
      wrap.querySelectorAll('noscript').forEach(function (ns) {
        document.body.appendChild(ns.cloneNode(true));
      });
    } catch (e) {}
  }

  function activateExternalScripts(category, done) {
    var nodes = document.querySelectorAll('script[data-uf-cookie-external="' + category + '"]');
    if (!nodes.length) {
      if (done) done();
      return;
    }

    var remaining = nodes.length;
    nodes.forEach(function (node) {
      var src = node.getAttribute('data-src');
      if (!src) {
        remaining--;
        if (remaining <= 0 && done) done();
        node.remove();
        return;
      }

      var script = document.createElement('script');
      script.async = true;
      script.src = src;
      script.onload = script.onerror = function () {
        remaining--;
        if (remaining <= 0 && done) done();
      };
      document.head.appendChild(script);
      node.remove();
    });
  }

  function activateInlineScripts(category) {
    document.querySelectorAll('script[data-uf-cookie-inline="' + category + '"]').forEach(function (node) {
      var script = document.createElement('script');
      script.text = node.text || node.textContent || '';
      document.head.appendChild(script);
      node.remove();
    });
  }

  function activateTemplates(category) {
    document.querySelectorAll('template[data-uf-cookie-consent="' + category + '"]').forEach(function (tmpl) {
      injectHtmlScripts(tmpl.innerHTML);
      tmpl.remove();
    });
  }

  function activateCategory(category) {
    activateExternalScripts(category, function () {
      activateInlineScripts(category);
      activateTemplates(category);
    });
  }

  function updateMetaPixelConsent(choices) {
    if (typeof window.fbq !== 'function') return;
    try {
      if (choices.marketing) {
        window.fbq('consent', 'grant');
        // PageView onder revoke wordt niet verstuurd — 1x opnieuw na grant
        if (!window.__ufMetaPageViewSent) {
          window.fbq('track', 'PageView');
          window.__ufMetaPageViewSent = true;
        }
      } else {
        window.fbq('consent', 'revoke');
        window.__ufMetaPageViewSent = false;
      }
    } catch (e) {}
  }

  function applyConsent(choices) {
    try {
      updateGtagConsent(choices);
      updateMetaPixelConsent(choices);
      if (choices.analytics) activateCategory('analytics');
      if (choices.marketing) activateCategory('marketing');
      syncShopify(choices);
      try {
        document.dispatchEvent(
          new CustomEvent('uf:cookie-consent', {
            detail: {
              analytics: !!choices.analytics,
              marketing: !!choices.marketing
            }
          })
        );
      } catch (e2) {}
    } catch (e) {}
  }

  function mountBar(wrap) {
    if (document.body) {
      document.body.appendChild(wrap);
      return;
    }
    document.documentElement.appendChild(wrap);
  }

  function readToggleChoices(bar) {
    var root = bar || document.getElementById('uf-cookiebar');
    if (!root) {
      return { analytics: false, marketing: false };
    }
    var analyticsEl = root.querySelector('#uf-cookie-analytics');
    var marketingEl = root.querySelector('#uf-cookie-marketing');
    return {
      analytics: analyticsEl ? analyticsEl.checked : false,
      marketing: marketingEl ? marketingEl.checked : false
    };
  }

  function handleBarAction(action, bar) {
    if (!action || action === 'prefs') {
      return false;
    }

    if (action === 'close') {
      removeBanner();
      return true;
    }

    var choices;

    if (action === 'accept-all') {
      choices = writeConsent({ analytics: true, marketing: true });
    } else if (action === 'necessary') {
      choices = writeConsent({ analytics: false, marketing: false });
    } else if (action === 'save') {
      choices = writeConsent(readToggleChoices(bar));
    } else {
      return false;
    }

    applyConsent(choices);
    removeBanner();
    return true;
  }

  function hideShopifyBanner() {
    ['#shopify-pc__banner', '.shopify-pc__banner'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.style.display = 'none';
    });
  }

  function removeBanner() {
    var bar = document.getElementById('uf-cookiebar');
    if (bar) bar.remove();
    var backdrop = document.getElementById('uf-cookiebar-backdrop');
    if (backdrop) backdrop.remove();
    document.documentElement.classList.remove('uf-cookiebar-open', 'uf-cookiebar-open--prefs');
    syncBodyBarOffset();
  }

  function syncBodyBarOffset() {
    if (!document.body) return;
    var bar = document.getElementById('uf-cookiebar');
    if (!bar) {
      document.body.style.paddingBottom = '';
      return;
    }
    document.body.style.paddingBottom = bar.offsetHeight + 'px';
  }

  function setPrefsScrollLock(active) {
    /* Geen scroll-lock: bezoeker mag de site blijven bekijken */
    document.documentElement.classList.remove('uf-cookiebar-open--prefs');
  }

  function ensureBackdrop(show) {
    var backdrop = document.getElementById('uf-cookiebar-backdrop');
    if (backdrop) backdrop.remove();
  }

  function isWarmEarthTheme() {
    return document.body && document.body.classList.contains('uf-design-warm-earth-1');
  }

  function applyThemeClass(el, warmClass) {
    if (!el) return;
    if (isWarmEarthTheme()) {
      el.classList.add(warmClass);
    } else {
      el.classList.remove(warmClass);
    }
  }

  function setBarModeClass(bar, mode) {
    bar.className = mode === 'prefs' ? 'uf-cookiebar uf-cookiebar--prefs' : 'uf-cookiebar';
    applyThemeClass(bar, 'uf-cookiebar--warm-earth');
  }

  function buildToggle(id, label, desc, checked, disabled) {
    return (
      '<div class="uf-cookiebar__pref">' +
        '<div>' +
          '<p class="uf-cookiebar__pref-title">' + label + '</p>' +
          '<p class="uf-cookiebar__pref-desc">' + desc + '</p>' +
        '</div>' +
        '<label class="uf-cookiebar__toggle" for="' + id + '">' +
          '<input type="checkbox" id="' + id + '" ' + (checked ? 'checked' : '') + (disabled ? ' disabled' : '') + '>' +
          '<span class="uf-cookiebar__toggle-track" aria-hidden="true"></span>' +
          '<span class="uf-cookiebar__toggle-thumb" aria-hidden="true"></span>' +
        '</label>' +
      '</div>'
    );
  }

  function createBanner(initial, startMode) {
    var existing = document.getElementById('uf-cookiebar');
    if (existing) existing.remove();
    ensureBackdrop(false);

    var saved = initial || readConsent();
    var showPrefs = startMode === 'prefs';

    function render(mode) {
      showPrefs = mode === 'prefs';
      var bar = document.getElementById('uf-cookiebar');
      if (!bar) return;

      setPrefsScrollLock(showPrefs);
      ensureBackdrop(showPrefs);

      var analyticsChecked = saved ? saved.analytics : false;
      var marketingChecked = saved ? saved.marketing : false;

      if (showPrefs) {
        setBarModeClass(bar, 'prefs');
        bar.innerHTML =
          '<div class="uf-cookiebar__inner">' +
            '<div class="uf-cookiebar__header">' +
              '<div class="uf-cookiebar__copy">' +
                '<div class="uf-cookiebar__title">Cookievoorkeuren</div>' +
                '<p class="uf-cookiebar__text">Kies welke cookies wij mogen plaatsen. Noodzakelijke cookies zijn altijd actief voor een goed werkende webshop.</p>' +
              '</div>' +
              '<button type="button" class="uf-cookiebar__close" data-uf-cookie-action="close" aria-label="Sluiten">' +
                '<span aria-hidden="true">&times;</span>' +
              '</button>' +
            '</div>' +
            '<div class="uf-cookiebar__prefs">' +
              buildToggle(
                'uf-cookie-necessary',
                'Noodzakelijke cookies',
                'Voor winkelwagen, checkout, beveiliging en basisfuncties van de site.',
                true,
                true
              ) +
              buildToggle(
                'uf-cookie-analytics',
                'Analytische cookies',
                'Helpen ons te begrijpen hoe bezoekers de site gebruiken (bijv. Google Analytics).',
                analyticsChecked,
                false
              ) +
              buildToggle(
                'uf-cookie-marketing',
                'Marketingcookies',
                'Voor gepersonaliseerde advertenties, remarketing en conversiemeting (Meta Pixel, Google Ads).',
                marketingChecked,
                false
              ) +
            '</div>' +
            '<div class="uf-cookiebar__prefs-accept">' +
              '<button type="button" class="uf-cookiebar__btn uf-cookiebar__btn--primary uf-cookiebar__btn--block" data-uf-cookie-action="save">Accepteren</button>' +
            '</div>' +
            '<div class="uf-cookiebar__actions">' +
              '<button type="button" class="uf-cookiebar__btn uf-cookiebar__btn--ghost" data-uf-cookie-action="necessary">Alleen noodzakelijk</button>' +
              '<button type="button" class="uf-cookiebar__btn uf-cookiebar__btn--secondary" data-uf-cookie-action="accept-all">Alles accepteren</button>' +
              '<a class="uf-cookiebar__btn uf-cookiebar__btn--link" href="' + privacyUrl + '">Privacybeleid</a>' +
            '</div>' +
          '</div>';
      } else {
        setBarModeClass(bar, 'banner');
        bar.innerHTML =
          '<div class="uf-cookiebar__inner">' +
            '<div class="uf-cookiebar__copy">' +
              '<div class="uf-cookiebar__title">Cookies op ' + (cfg.shopName || 'deze website') + '</div>' +
              '<p class="uf-cookiebar__text">Wij gebruiken cookies om de webshop te laten werken, statistieken bij te houden en marketing te meten (Meta Pixel, Google Ads). Kies zelf welke cookies u accepteert. Lees meer in ons <a href="' + privacyUrl + '">privacybeleid</a>.</p>' +
            '</div>' +
            '<div class="uf-cookiebar__actions">' +
              '<button type="button" class="uf-cookiebar__btn uf-cookiebar__btn--ghost" data-uf-cookie-action="necessary">Alleen noodzakelijk</button>' +
              '<button type="button" class="uf-cookiebar__btn uf-cookiebar__btn--secondary" data-uf-cookie-action="prefs">Voorkeuren</button>' +
              '<button type="button" class="uf-cookiebar__btn uf-cookiebar__btn--primary" data-uf-cookie-action="accept-all">Alles accepteren</button>' +
            '</div>' +
          '</div>';
      }

      if (showPrefs) {
        bar.scrollTop = 0;
        var prefs = bar.querySelector('.uf-cookiebar__prefs');
        if (prefs) prefs.scrollTop = 0;
      }

      syncBodyBarOffset();
      window.requestAnimationFrame(syncBodyBarOffset);
    }

    var wrap = document.createElement('div');
    wrap.id = 'uf-cookiebar';
    wrap.className = 'uf-cookiebar';
    applyThemeClass(wrap, 'uf-cookiebar--warm-earth');
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'false');
    wrap.setAttribute('aria-live', 'polite');
    wrap.setAttribute('aria-label', 'Cookievoorkeuren');
    mountBar(wrap);
    document.documentElement.classList.add('uf-cookiebar-open');
    render(startMode === 'prefs' ? 'prefs' : 'banner');

    function onBarActivate(e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-uf-cookie-action]') : null;
      if (!btn || !wrap.contains(btn)) return;

      var action = btn.getAttribute('data-uf-cookie-action');

      if (action === 'prefs') {
        e.preventDefault();
        render('prefs');
        return;
      }

      if (btn.tagName === 'BUTTON') {
        e.preventDefault();
      }

      handleBarAction(action, wrap);
    }

    wrap.addEventListener('click', onBarActivate);
  }

  function init() {
    hideShopifyBanner();

    var saved = readConsent();
    if (saved) {
      applyConsent(saved);
      return;
    }

    applyConsent({ necessary: true, analytics: false, marketing: false });
    createBanner(null);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('[data-uf-cookie-open-settings]') : null;
    if (!trigger) return;
    e.preventDefault();
    createBanner(
      readConsent() || { necessary: true, analytics: false, marketing: false },
      'prefs'
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', syncBodyBarOffset, { passive: true });
})();
